module.exports = __webpack_public_path__ + "components/home-header/static/header-5--large@2x-04957bbc95bcbb3d12e80511ace1ca0c.jpg";